module.exports = __webpack_public_path__ + "static/img/img_service_process@3x.a7375c1e.png";